import { Controller } from "@hotwired/stimulus";
import Panzoom from "@panzoom/panzoom";

const DEFAULT_OPTIONS = {
  MAX_SCALE: 2,
  MIN_SCALE: 0.75,
  START_SCALE: 1,
};

export default class extends Controller {
  connect() {
    this._setupZoomableElement();
  }

  _setupZoomableElement() {
    const panzoom = Panzoom(this.element, { maxScale: DEFAULT_OPTIONS.MAX_SCALE, minScale: DEFAULT_OPTIONS.MIN_SCALE });
    panzoom.zoom(DEFAULT_OPTIONS.START_SCALE, { animate: true });
  }
}
